import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'
import { Badge, Card, Col, Collapse, Modal, Row } from 'react-bootstrap'

export function ModalReplicarResultsBatch({ isOpen, onClose, results }) {
  const [expandedItems, setExpandedItems] = useState({})
  const [expandedSuccessItems, setExpandedSuccessItems] = useState({})

  const itemsSucceedCount = Object.values(results?.success || {}).reduce(
    (acc, item) => {
      Object.values(item).forEach((itemKey) => (acc = acc + itemKey.length))
      return acc
    },
    0,
  )

  const itemsFailedCount = Object.values(results?.error || {}).reduce(
    (acc, item) => {
      Object.values(item).forEach((itemKey) => (acc = acc + itemKey.length))
      return acc
    },
    0,
  )

  const toggleItem = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  const toggleSuccessItem = (index) => {
    setExpandedSuccessItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size="lg"
      className="modal-modern"
    >
      <Modal.Header
        closeButton
        className="border-0 pb-0"
      >
        <Modal.Title className="fw-bold">
          Resultado da Replicação em Massa
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        <Row className="g-4">
          <Col md={6}>
            <Card className="border-0 shadow-sm bg-success bg-opacity-10">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="mb-0 text-success fw-semibold">
                    <i className="bi bi-check-circle-fill me-2"></i>
                    Sucesso
                  </h5>
                  <Badge
                    bg="success"
                    pill
                    className="px-3 py-2"
                  >
                    {itemsSucceedCount}
                  </Badge>
                </div>

                {itemsSucceedCount > 0 ? (
                  <div className="mt-3">
                    {Object.entries(results?.success || {}).map(
                      ([mlbKey, accounts], mlbIndex) => (
                        <Card
                          key={mlbIndex}
                          className="mb-3 border border-success border-opacity-25"
                        >
                          <Card.Header className="bg-success bg-opacity-10 border-0 py-2">
                            <Badge
                              bg="success"
                              className="px-3 py-2"
                            >
                              {mlbKey}
                            </Badge>
                          </Card.Header>
                          <Card.Body className="p-2">
                            {Object.entries(accounts || {}).map(
                              ([accountKey, messages], accountIndex) => (
                                <Card
                                  key={accountIndex}
                                  className="mb-2 border-0 shadow-sm"
                                >
                                  <Card.Header
                                    className="bg-white border-bottom py-2 cursor-pointer"
                                    onClick={() =>
                                      toggleSuccessItem(
                                        `${mlbIndex}-${accountIndex}`,
                                      )
                                    }
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className="text-success fw-semibold small">
                                        {accountKey}
                                      </span>
                                      <div className="d-flex align-items-center gap-2">
                                        <Badge
                                          bg="success"
                                          className="px-2 py-1"
                                        >
                                          {messages.length}
                                        </Badge>
                                        {expandedSuccessItems[
                                          `${mlbIndex}-${accountIndex}`
                                        ] ? (
                                          <ChevronUp
                                            size={16}
                                            className="text-success"
                                          />
                                        ) : (
                                          <ChevronDown
                                            size={16}
                                            className="text-success"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </Card.Header>
                                  <Collapse
                                    in={
                                      expandedSuccessItems[
                                        `${mlbIndex}-${accountIndex}`
                                      ]
                                    }
                                  >
                                    <Card.Body className="pt-2 pb-3">
                                      <ul className="mb-0 ps-3 text-success small">
                                        {messages.map((message, msgIndex) => (
                                          <li
                                            key={msgIndex}
                                            className="mb-1"
                                          >
                                            {message}
                                          </li>
                                        ))}
                                      </ul>
                                    </Card.Body>
                                  </Collapse>
                                </Card>
                              ),
                            )}
                          </Card.Body>
                        </Card>
                      ),
                    )}
                  </div>
                ) : (
                  <div className="text-success small opacity-75">
                    Nenhum sucesso registrado
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="border-0 shadow-sm bg-danger bg-opacity-10">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="mb-0 text-danger fw-semibold">
                    <i className="bi bi-x-circle-fill me-2"></i>
                    Falhas
                  </h5>
                  <Badge
                    bg="danger"
                    pill
                    className="px-3 py-2"
                  >
                    {itemsFailedCount}
                  </Badge>
                </div>

                {itemsFailedCount > 0 ? (
                  <div className="mt-3">
                    {Object.entries(results?.error || {}).map(
                      ([mlbKey, accounts], mlbIndex) => (
                        <Card
                          key={mlbIndex}
                          className="mb-3 border border-danger border-opacity-25"
                        >
                          <Card.Header className="bg-danger bg-opacity-10 border-0 py-2">
                            <Badge
                              bg="danger"
                              className="px-3 py-2"
                            >
                              {mlbKey}
                            </Badge>
                          </Card.Header>
                          <Card.Body className="p-2">
                            {Object.entries(accounts || {}).map(
                              ([accountKey, messages], accountIndex) => (
                                <Card
                                  key={accountIndex}
                                  className="mb-2 border-0 shadow-sm"
                                >
                                  <Card.Header
                                    className="bg-white border-bottom py-2 cursor-pointer"
                                    onClick={() =>
                                      toggleItem(`${mlbIndex}-${accountIndex}`)
                                    }
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className="text-danger fw-semibold small">
                                        {accountKey}
                                      </span>
                                      <div className="d-flex align-items-center gap-2">
                                        <Badge
                                          bg="danger"
                                          className="px-2 py-1"
                                        >
                                          {messages.length}
                                        </Badge>
                                        {expandedItems[
                                          `${mlbIndex}-${accountIndex}`
                                        ] ? (
                                          <ChevronUp
                                            size={16}
                                            className="text-danger"
                                          />
                                        ) : (
                                          <ChevronDown
                                            size={16}
                                            className="text-danger"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </Card.Header>
                                  <Collapse
                                    in={
                                      expandedItems[
                                        `${mlbIndex}-${accountIndex}`
                                      ]
                                    }
                                  >
                                    <Card.Body className="pt-2 pb-3">
                                      <ul className="mb-0 ps-3 text-danger small">
                                        {messages.map((message, msgIndex) => (
                                          <li
                                            key={msgIndex}
                                            className="mb-1"
                                          >
                                            {message}
                                          </li>
                                        ))}
                                      </ul>
                                    </Card.Body>
                                  </Collapse>
                                </Card>
                              ),
                            )}
                          </Card.Body>
                        </Card>
                      ),
                    )}
                  </div>
                ) : (
                  <div className="text-danger small opacity-75">
                    Nenhuma falha registrada
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <button
          className="btn btn-secondary px-4"
          onClick={onClose}
        >
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  )
}
